const isBuildYourOwnHamper = (productSlug: string) => {
    if (productSlug && productSlug === 'create-your-own-hamper') {
        return true;
    }

    return false;
};

export default isBuildYourOwnHamper;
